import React from 'react';
import PropTypes from 'prop-types';
import lockedIcon from '@/../images/icons/lock.svg';
import styles from '../../Navigator.module.scss';
import useKeyboardNavigation from '../../../../Builder/useKeyboardNavigation.ts';
import useSlideShowContext from '../../../../stores/useSlideShowContext';
import useSessionNavigationLock from '../../../useSessionNavigationLock';
import PositionInput from './PositionInput';
import NavigationButton from './NavigationButton';

const Navigation = ({
  dropdownItemText,
  onBack,
  onDirectNav,
  onForward,
  numElements,
  position,
}) => {
  const formattedSlides = useSlideShowContext(state => state.slides);
  const { isNavigationLocked } = useSessionNavigationLock();

  useKeyboardNavigation({
    backKeys: ['ArrowLeft', 'Backspace', 'PageUp'],
    disabled: isNavigationLocked,
    forwardKeys: ['ArrowRight', 'Enter', ' ', 'PageDown'],
    numElements,
    onBack,
    onForward,
    position,
  });

  return (
    <div className={styles.navigation}>
      { !isNavigationLocked ? (
        <NavigationButton
          disabled={isNavigationLocked || position === 1}
          faIcon="fa-chevron-left"
          label="Previous Slide"
          sessionLocked={isNavigationLocked}
          slide={formattedSlides[position - 2]}
          onClick={onBack}
        />
      ) : <img alt="lock icon" className={`${styles.navigatorButton} !tw-cursor-default`} src={lockedIcon} />}

      <PositionInput
        dropdownItemText={dropdownItemText}
        numElements={numElements}
        position={position}
        sessionLocked={isNavigationLocked}
        onDirectNav={onDirectNav}
      />

      { !isNavigationLocked && (
        <NavigationButton
          disabled={isNavigationLocked || position === numElements}
          faIcon="fa-chevron-right"
          label="Next Slide"
          slide={formattedSlides[position]}
          onClick={onForward}
        />
      )}
    </div>
  );
};

Navigation.defaultProps = {
  dropdownItemText: 'Item',
};

export const NavigationPropTypes = PropTypes.shape({
  dropdownItemText: PropTypes.string,
  onBack: PropTypes.func.isRequired,
  onDirectNav: PropTypes.func.isRequired,
  onForward: PropTypes.func.isRequired,
  numElements: PropTypes.number.isRequired,
  position: PropTypes.number.isRequired,
});

Navigation.propTypes = NavigationPropTypes.isRequired;

export default Navigation;
